import common from '../../common/common';
const configHelper = require('../../config/index');

const generateCmsUrl = (partialUrl) =>
    `${configHelper.getConfig().cms.cmsUrl}${partialUrl}`;

const generateBlogRootUrl = () => `${common.getSiteUrl()}/news`;

const creativeWorkStatusTypes = {
    published: 'Published',
    draft: 'Draft',
    obsolete: 'Obsolete',
};

const getCmsAssetsMediaUrl = () => {
    const useCdn = configHelper.getConfig().useCdn;
    return useCdn
        ? `${configHelper.getConfig().cdnCmsAssetsUrl}`
        : `${configHelper.getConfig().cms.cmsUrl}/uploads`;
};

export {
    generateCmsUrl,
    generateBlogRootUrl,
    creativeWorkStatusTypes,
    getCmsAssetsMediaUrl,
};
